/**
 * Presentation-boundary normalization for registration toast feedback.
 *
 * Backend POST /api/users/register/ may return `detail` as a string or a list.
 * Redux stores that payload as-is; this helper turns it into one readable
 * message without character-slicing strings as arrays.
 */

export const REGISTER_ERROR_FALLBACK_MESSAGE =
  'Не вдалося створити акаунт. Спробуйте ще раз.';

function trimNonEmptyString(value) {
  if (typeof value !== 'string') {
    return '';
  }
  return value.trim();
}

export function normalizeRegisterErrorMessage(
  error,
  fallback = REGISTER_ERROR_FALLBACK_MESSAGE,
) {
  if (error == null || error === '') {
    return fallback;
  }

  if (typeof error === 'string') {
    const trimmed = trimNonEmptyString(error);
    return trimmed || fallback;
  }

  if (Array.isArray(error)) {
    const parts = error
      .map((item) => {
        if (typeof item === 'string') {
          return trimNonEmptyString(item);
        }
        if (item == null) {
          return '';
        }
        if (typeof item === 'object') {
          return '';
        }
        return trimNonEmptyString(String(item));
      })
      .filter(Boolean);
    return parts.length > 0 ? parts.join(' ') : fallback;
  }

  if (typeof error === 'object') {
    if (
      Object.prototype.hasOwnProperty.call(error, 'detail') &&
      error.detail !== error
    ) {
      return normalizeRegisterErrorMessage(error.detail, fallback);
    }
    const message = trimNonEmptyString(error.message);
    if (message) {
      return message;
    }
  }

  return fallback;
}
